/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Compliance_EuaiInputs */

const en_landing_compliance_euai = /** @type {(inputs: Landing_Compliance_EuaiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EU AI Act Article 50`)
};

const de_landing_compliance_euai = /** @type {(inputs: Landing_Compliance_EuaiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artikel 50 des EU-KI-Gesetzes`)
};

const fr_landing_compliance_euai = /** @type {(inputs: Landing_Compliance_EuaiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Article 50 du règlement européen sur l’IA`)
};

const es_landing_compliance_euai = /** @type {(inputs: Landing_Compliance_EuaiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artículo 50 de la Ley de IA de la UE`)
};

const it_landing_compliance_euai = /** @type {(inputs: Landing_Compliance_EuaiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Articolo 50 dell’AI Act dell’UE`)
};

const nl_landing_compliance_euai = /** @type {(inputs: Landing_Compliance_EuaiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artikel 50 van de EU-AI-verordening`)
};

const pl_landing_compliance_euai = /** @type {(inputs: Landing_Compliance_EuaiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Art. 50 unijnego aktu w sprawie AI`)
};

const fi_landing_compliance_euai = /** @type {(inputs: Landing_Compliance_EuaiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EU:n tekoälysäädöksen 50 artikla`)
};

const da_landing_compliance_euai = /** @type {(inputs: Landing_Compliance_EuaiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artikel 50 i EU’s AI-forordning`)
};

const sv_landing_compliance_euai = /** @type {(inputs: Landing_Compliance_EuaiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artikel 50 i EU:s AI-förordning`)
};

/**
* | output |
* | --- |
* | "EU AI Act Article 50" |
*
* @param {Landing_Compliance_EuaiInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_compliance_euai = /** @type {((inputs?: Landing_Compliance_EuaiInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Compliance_EuaiInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_compliance_euai(inputs)
	if (locale === "fr") return fr_landing_compliance_euai(inputs)
	if (locale === "es") return es_landing_compliance_euai(inputs)
	if (locale === "it") return it_landing_compliance_euai(inputs)
	if (locale === "nl") return nl_landing_compliance_euai(inputs)
	if (locale === "pl") return pl_landing_compliance_euai(inputs)
	if (locale === "fi") return fi_landing_compliance_euai(inputs)
	if (locale === "da") return da_landing_compliance_euai(inputs)
	if (locale === "sv") return sv_landing_compliance_euai(inputs)
	return en_landing_compliance_euai(inputs)
});